import { render } from "./StatementItem.vue?vue&type=template&id=4f81028b&ts=true&lang=pug"
import script from "./StatementItem.vue?vue&type=script&lang=ts"
export * from "./StatementItem.vue?vue&type=script&lang=ts"

import "./StatementItem.vue?vue&type=style&index=0&id=4f81028b&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__